import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/auth';

export function GuestGuard() {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full" />
      </div>
    );
  }

  if (isAuthenticated) {
    const destination = user?.platformRole ? '/platform-admin/dashboard' : '/dashboard';
    return <Navigate to={destination} replace />;
  }

  return <Outlet />;
}
